import { render, staticRenderFns } from "./TemplateDebts.vue?vue&type=template&id=b4c21830&scoped=true"
import script from "./TemplateDebts.vue?vue&type=script&lang=js"
export * from "./TemplateDebts.vue?vue&type=script&lang=js"
import style0 from "./TemplateDebts.vue?vue&type=style&index=0&id=b4c21830&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c21830",
  null
  
)

export default component.exports